// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"743b2291","632":"41561405","736":"1e464ce3","968":"01d65a23"}[chunkId] + ".chunk.js";
};